// Parses the raw accessibilityRules string the backend returns (FULL, HIDDEN, READ_ONLY,
// SUBSCRIBE_REQUIRED) into a consistent { level, limit } shape. `limit` is always null now -
// RESTRICTED (the only level that ever set it, via a "RESTRICTED:N" encoding) was removed:
// never had any real enforcement anywhere, only ever displayed the configured number. Kept in
// the return shape rather than removed outright, so callers destructuring `limit` don't need
// touching for a value that was already never meaningfully used beyond display.
export function parseAccessibilityRule(raw) {
  if (!raw) return { level: "FULL", limit: null };
  return { level: raw, limit: null };
}

// Shared by useVisibleServices and useAccessibleServices: resolves a service's accessibility
// level from accessibilityRules[service.accessKey] and whether it's HIDDEN. The two hooks are
// intentionally different views (catalog-with-locked-tiles vs. currently-usable-only) and must
// keep their own filtering/sorting rules, but they were each re-deriving this same level/HIDDEN
// lookup slightly differently — this centralizes just that one shared computation.
export function getServiceAccessibilityLevel(service, accessibilityRules) {
  const raw = service.accessKey ? accessibilityRules?.[service.accessKey] : null;
  const { level } = parseAccessibilityRule(raw);
  return { raw, level, isHidden: level === "HIDDEN" };
}
